export class NonceService {
    constructor(ajaxUrl) {
        this.ajaxUrl = ajaxUrl;
    }
    init() {
        return this.fetchNonces();
    }
    fetchNonces() {
        return fetch(`${this.ajaxUrl}?action=perla_get_nonce`, {
            credentials: 'include',
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error(`Failed to fetch nonces: ${response.statusText}`);
            }
            return response.json();
        })
            .then((data) => {
            window.perlaData = Object.assign(Object.assign({}, window.perlaData), data);
            console.log('Nonces updated globally:', window.perlaData);
        })
            .catch((error) => {
            console.error('Error fetching nonces:', error);
        });
    }
}
